import SavePaymentData from "../../logic/payment/SavePayment";

export default {
    mixins: [],
    data: () => ({}),
    computed: {

    },
    methods: {
        closeModalPaypalError() {
            document.getElementById('modalPaypalError').classList.add("hidden");
        },
        closeModalSaleError() {
            document.getElementById('modalSaleError').classList.add("hidden");
        },
        /**
         * The function creates an order, then captures the order, then saves the order data to the
         * database
         * SmartPaymentBotom | PayPal
         */
        async PayPalButtons() {
            try {
                let parameters = {};
                /* Getting the shopping cart from the store. */
                parameters.ShoppingCart = Object.values(this.$store.state.shoppingCart);
                /* Adding the email to the parameters object. */
                parameters.email = this.$store.state.email;
                /* Adding the country to the parameters object. */
                parameters.country = this.$store.state.Currency;

                paypal.Buttons({
                        // Sets up the transaction when a payment button is clicked
                        createOrder: () => {
                            /* Returning the merchantOrderId from the Booking function. */
                            return this.Booking()
                                .then((response) => {
                                    parameters.salesId    = response.salesId;
                                    parameters.dsSalesId  = response.dsSalesId;
                                    parameters.merchantOrderId = response.merchantOrderId;
                                    const merchantOrderId = parameters.merchantOrderId || "";

                                    return merchantOrderId;
                                })
                                .catch(() => {
                                    Vue.$toast.open({
                                        message: this.$t("paypal.create_order_error"),
                                        type: "error",
                                    });
                                });
                        },
                        // Finalize the transaction after payer approval
                        onApprove: (data, actions) => {
                                    /* Removing the class hidden from the element with the id modalPaypalSuccess. */
                                    document.getElementById('modalPaypalSuccess').classList.remove("hidden");
                                    /* Saving the payment data to the database. */
                                    const SavePayment = SavePaymentData.post(parameters)
                                        .then((response) => {
                                            const lang = document.documentElement.lang;
                                            const base = window.location.origin;

                                            // Clear Shopping Cart
                                            SavePaymentData.clearShoppingCart();

                                            /* Creating a url with the base url and the id of the sale. */
                                            const urlDefault = `${base}/successful-payment/${response.dsSaleID}`;
                                            /* Creating a url with the language and the id of the sale. */
                                            const urlSpanish = `${base}/es/successful-payment/${response.dsSaleID}`;
                                            /* Getting the element with the id linkRedirectPaypal. */
                                            // const element = document.getElementById('linkRedirectPaypal');

                                            if (lang == "es") {
                                                /* Redirecting the user to the urlSpanish variable. */
                                                location.href = urlSpanish;
                                            }

                                            /* Redirecting the user to the urlDefault variable. */
                                            location.href = urlDefault;
                                        })
                                        .catch((error) => {
                                            
                                            /* Getting the element with the id paypal_error_transaction_status. */
                                            const transaction_status = document.getElementById('paypal_error_transaction_status');
                                            /* Getting the element with the id paypal_error_transaction_id. */
                                            const transaction_id = document.getElementById('paypal_error_transaction_id');
                                            /* Getting the transaction data from the orderData object. */
                                            const transaction = orderData.purchase_units[0].payments.captures[0];
                                            /* Getting the element with the id paypal_error_transaction_status and setting the innerText to the transaction status. */
                                            transaction_status.innerText = transaction.status;
                                            /* Getting the element with the id paypal_error_transaction_id and setting the innerText to the transaction id. */
                                            transaction_id.innerText = transaction.id;
                                            /* Adding the class hidden to the element with the id modalPaypalSuccess. */
                                            document.getElementById('modalPaypalSuccess').classList.add("hidden");
                                            /* Removing the class hidden from the element with the id modalPaypalError. */
                                            document.getElementById('modalPaypalError').classList.remove("hidden");
                                        });
                        },
                    })
                    .render("#paypal-button-container");
            } catch (error) {
                
            }
        }
    }
};